import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthguradServiceService {
  constructor() {}
  gettoken() {
    return !!localStorage.getItem('AccessToken');
  }
  isRoleAllow = new Subject<any>();
}
